<article
  #dropdownWrapper
  [style.top]="isMobileScreen ? '3px' : '10px'"
  [className]="isRtl() ? ' container right' : ' container left'"
>
  <div #profileCard class="logged-in-user-container">
    <section class="logged-in-user-image-container">
      @if (!loggedInUser?.profilePicture) {
      <div class="user-initials">
        <p class="name">
          {{extractInitials(loggedInUser?.['user.name' | translate])}}
        </p>
      </div>
      } @else {
      <figure class="icon-wrapper">
        <img
          [src]="loggedInUser?.profilePicture"
          alt="profile picture"
          class="icon"
        />
      </figure>
      }
    </section>
    <section
      [style.display]="isMobileScreen ? 'none' : 'flex'"
      class="logged-in-user-name-role"
    >
      <div class="name">
        <p class="name-display">{{loggedInUser?.['user.name' | translate]}}</p>
      </div>
      <div class="role">
        <p class="text">{{ roles[role] | translate }}</p>
      </div>
    </section>
    <section class="arrow-container" (click)="openCloseDropDown()">
      <figure>
        <img
          [style.transform]="isDropDownOpen ? 'scaleY(-1)' : 'scaleY(1)'"
          src="svgs/header/arrow-down.svg"
          alt="Arrow Down"
        />
      </figure>
    </section>
  </div>

  <nav
    class="main-nav-list"
    [hidden]="!isDropDownOpen"
    [style.width]="profileCard.offsetWidth + 'px'"
  >
    <ul class="list">
      @for (dropDownItem of dropDownItems; track $index) {
      <li (click)="isDropDownOpen = false">
        <a
          class="link"
          [routerLink]="dropDownItem.route[0]"
          [ngClass]="{ active: isCurrentRouteActive(dropDownItem) }"
          ariaCurrentWhenActive="page"
        >
          <img
            [src]="getDropDownItemIcon(dropDownItem)"
            [alt]="dropDownItem.alt"
          />

          <span class="text">{{
            dropDownItem.translationPath | translate
          }}</span>
        </a>
      </li>

      }
    </ul>
  </nav>
</article>
